/**
 * Created by Ricardo on 18-02-2018.
 */
import {ToastOptions} from 'ng2-toastr';

export class CustomOption extends ToastOptions {
  toastLife = 60000;
  showCloseButton = true;

}



// WEBPACK FOOTER //
// /app/src/app/config/custom-toast-options.ts